import styled from 'styled-components'

export const UserManagementLegacyWrapper = styled.div`
  .SearchAndFilters {
    padding-left: 40px;
  }

  h1 {
    margin-left: 40px;
  }
  .user-container {
    display: flex;
    justify-content: space-between;
    .add-user {
      margin-right: 40px;
      margin-top: 10px;
    }
  }
  .user-filters {
    overflow: hidden;
    padding: 30px 40px;
    background-color: ${props => props.theme.colors.white};

    .role-filter,
    .status-filter,
    .client-filter {
      float: right;
      margin-left: 30px;
      .form-select {
        width: 165px !important;
      }
    }
  }

  .breadcrumbs {
    margin-bottom: 30px;
  }

  table {
    th:first-child {
      padding-left: 40px;
    }
    tbody td:first-child {
      padding-left: 40px;
    }

    th:last-child {
      padding-right: 40px;
    }
    tbody td:last-child {
      padding-right: 30px;
    }
  }
`
